import { PopperBase } from './popper-base';
import { Global, LineMenu } from "../model";
import {
  PLANNER_CLOSE_DIALOG_CREATE_SCHEDULE,
  PLANNER_CLICK_REMOVE_LINE,
  PLANNER_CLICK_ADD_LINE
 } from 'apps/events';
import PopperJS from 'popper.js';
import { save, destroy }        from "apps/actions/common";

class DialogLineMenu extends PopperBase {
  multiline: boolean = false;
  init(){
    super.init();
    this.watchPlannerData('lineMenu', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeLineMenu(newVal, oldVal, objectPath)});
  }

  onChangeLineMenu(lineMenu: LineMenu, oldVal, objectPath) {
    if(lineMenu === null) {
      this.hide();
    } else {
      this.updateProperties(lineMenu);
      this.show(lineMenu);
    }
  }
  hide(){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.update();
  }
  show(lineMenu: LineMenu){
    this.isShow = true;
    let popper = new PopperJS(
      lineMenu.element,
      this.querySelector('.popper'),
      this.getPopperOptions()
    );
    this.update();
  }
  onClose(){
  }
  updateProperties(lineMenu: LineMenu){
    let lineData = Global.getLineData(lineMenu.lineId);
    let orderData = Global.getOrderData(lineData.order_id);
    this.multiline = orderData.lines.length > 1
  }
  onClickRemoveLine(){
    let customEvent = new CustomEvent(PLANNER_CLICK_REMOVE_LINE);
    document.dispatchEvent(customEvent);
  }
  onClickAddLine(){
    let customEvent = new CustomEvent(PLANNER_CLICK_ADD_LINE);
    document.dispatchEvent(customEvent);
  }
}
let scope = 'orders.planner.dialog.line-menu';
riot.mixin(scope, DialogLineMenu as riot.TagMixin);
